<template>
  <div class="AttemptedQuestionsList">
    <v-card class="mx-auto normal-card">
      <div class="data-table-section prev-test-tb cat-44">
        <v-data-table :headers="headers" fixed-header :items="items" hide-default-header hide-default-footer
          class="elevation-2 cust-table">
          <template v-slot:header="{ props: { headers } }">
            <TableHeader :headers="headers" :onSortChange="onSortChange" :onHeaderAction="onHeaderAction"
              :orderBy="orderBy" />
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item, index) in items" :key="item.id">
                <td class="qidclickview min-100 text-left" @click="onQIdClick(item, index)">
                  {{ item.question_id }}
                </td>
                <td class="duration-display min-200 text-left">
                  {{ getFormatedDate(item.attempt_date) }}
                </td>
                <td class="duration-display text-left">{{ item.question_type }}</td>
                <td class="duration-display text-left">{{ item.response }}</td>
                <td class="tdwidth-80">
                  <div :class="[
                    item.chapter_health < 20 ? 'redhealth' : item.chapter_health < 65 ? 'orangehealth' : 'greenhealth',
                  ]">{{ item.chapter_health }}%</div>
                </td>

                <td class="tdwidth-80">
                  <div class="text-center" :class="[
                    item.topic_health < 20 ? 'redhealth' : item.topic_health < 65 ? 'orangehealth' : 'greenhealth',
                  ]">
                    {{ item.topic_health }}%
                  </div>
                </td>
                <td class="dist-350 text-left">{{ item.concept_title }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left"></div>
      <div class="pull-right">
        <Pagination :currentPage="currentPage" :totalPage="totalPages" :onPageChange="onPageChange" />
      </div>
    </div>
    <div class="see-the-question">
      <div class="text-italic">Click on a Q.ID. to see the Question</div>
      <div class="Shortlisted">
        <div class="Shortlisted-text">{{ quesCount }} Q. Shortlisted</div>
        <v-btn v-if="checkBoostupSubscription() || isOnlineInstitute" class="right-btn cust-btn" color="primary" @click="requestCreateTest()" :disabled="isDisabled">
          Retry Shortlisted Questions
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";

export default {
  name: "BookmarkedAttemptedQuesList",
  props: [
    "subjectId",
    "chapterId",
    "topicId",
    "testTypeId",
    "functionCalls",
    "loadQuestions",    
    "checkStudentUpgraded",
  ],
  mounted() {
    this.defaultData();
    this.$root.showLoader = true;
    localStorage.removeItem("prevPath");
    localStorage.setItem('prevPath', this.$route.name);
  },
  data() {
    return {
      headers: [
        {
          text: "Q.ID",
          value: "question_id",
          class: "min-100 text-left",
        },
        {
          text: "Attempt Date",
          value: "attempt_date",
          class: "min-120 text-left",
        },
        {
          text: "Question Type",
          value: "question_type",
          class: "text-left",
          type: "multidropdown",
          options: this.questionTypes,
          allText: "All Question Types",
        },
        {
          text: "Response",
          value: "response",
          class: "text-left",
          type: "multidropdown",
          options: this.responseTypes,
          allText: "All Responses",
        },
        {
          text: "Chapter Health",
          value: "chapter_health",
          class: "text-center",
          hideSort: true,
        },
        {
          text: "Topic Health",
          value: "topic_health",
          class: "text-center",
          hideSort: true,
        },
        {
          text: "Concept Name",
          value: "concept_title",
          class: "text-left dist-300",
          hideSort: true,
        },
      ],
      items: [],
      currentPage: 1,
      practiceSession: false,
      pageSize: 10,
      totalPages: 1,
      orderBy: {
        order: "desc",
        field: "attempt_date",
      },
      selectedExamTypes: [],
      studentId: null,
      items: [],
      questionTypes: [],
      selectedQuestionType: [],
      responseTypes: constants.USER_ATTEMPT_STATUS_ARRAY,
      selectedResponseType: [],
      isDisabled: false,
      quesCount: null,
      bookmarkFilter: {},
      filterString: '',
      isApiCall: true,
      timeout:null
    };
  },
  computed: {
    ...mapState("userStore", ["user",'myInstitute']),
    isOnlineInstitute(){
				return constants.institute_ids.includes(this.myInstitute.id)
			}
  },

  methods: {
    ...mapActions({
      getTestTarget: "utilStore/getTestTarget",
      getPastTestList: "testStore/getPastTestList",
      getBookmarkQuestion: "testStore/getBookmarkQuestion",
      getAttemptedQuestions: "testStore/getAttemptedQuestions",
      getRefData: "utilStore/getRefData",
      showLoader: "testStore/showLoader",
      createTestForPracticeSession: "testStore/createTestForPracticeSession",
    }),
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd && crd.selectedTab) {
        this.selectedResponseType = crd.tabDetails[crd.selectedTab].response;
        this.selectedQuestionType = crd.tabDetails[crd.selectedTab].question_type;
      }
      this.studentId = this.user.id;
      this.requestGetQuestions();
      this.requestGetRefData();
      this.requestGetResponseData();
    },
    updateCurrentRouteDetails(fieldName, fieldValue) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      crd.tabDetails[crd.selectedTab][fieldName] = fieldValue;
      this.setRouteDetails(crd);
    },
    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    onQIdClick(item, index) {
      let bookmark_filter = {
        chapter_id: this.chapterId,
        topic_id: this.topicId,
        subject_id: this.subjectId,
        test_types: this.testTypeId,
        response_types: this.selectedResponseType,
        question_types: this.selectedQuestionType,
        orderBy: this.orderBy,
        page: this.currentPage,
      }
      localStorage.setItem('bookmarkFilter', JSON.stringify(bookmark_filter))
      this.$router.push({
        name: "bookmarked-question-details",
        params: {
          requiredCall: this.functionCalls,
          test_detail_id: item.test_detail_id,
          index: index,
          pageNumber: this.currentPage,
        },
      });
    },
    onFilterChange() {
      this.currentPage = 1;
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(()=>{
        this.requestGetQuestions();

      },500)
    },
    onSortChange() {
      this.requestGetQuestions();
    },
    onHeaderAction(e) {
      let headerValue = e.header.value
      let selectedItem = e.data.selectedItems
      if (
        e.header &&
        e.header.type === "multidropdown" &&
        headerValue === "question_type"
      ) {
        this.selectedQuestionType = e.data.selectedItems;
      }
      if (
        e.header &&
        e.header.type === "multidropdown" &&
        headerValue === "response"
      ) {
        this.selectedResponseType = e.data.selectedItems;
      }
      this.updateCurrentRouteDetails(headerValue, selectedItem);

    },
    requestGetQuestions() {
      this.$root.showLoader = true;
      let reqData = {
        user_id: this.studentId,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
        orderBy: this.orderBy,
      };
      if (this.subjectId) {
        reqData.subject_ids = [this.subjectId];
      }
      if (this.chapterId) {
        reqData.chapter_ids = this.chapterId;
      }
      if (this.topicId && this.topicId.length > 0) {
        reqData.topic_ids = this.topicId;
      }
      if (this.testTypeId && this.testTypeId.length > 0) {
        reqData.test_types = this.testTypeId;
      }
      if (this.selectedResponseType && this.selectedResponseType.length > 0) {
        reqData.response_types = this.selectedResponseType;
      }
      if (this.selectedQuestionType && this.selectedQuestionType.length > 0) {
        reqData.question_types = this.selectedQuestionType;
      }
      let fn = this.functionCalls;
      if (this.functionCalls == "bookmarked-questions") {
        fn = "getBookmarkQuestion";
      } else if (this.functionCalls == "attempted-questions") {
        fn = "getAttemptedQuestions";
      }
      this[fn](reqData)
        .then((response) => {
          this.isApiCall = false;
          this.items = response.list;
          this.quesCount = response.pagination.rowCount;
          this.isDisabled = this.quesCount == 0 ? true : false;
          if (
            this.selectedQuestionType.includes(this.QUE_TYPES.COMPREHENSION) ||
            this.selectedQuestionType.includes(this.QUE_TYPES.TC)
          ) {
            this.isDisabled = true;
          }
          this.totalPages = response.pagination.pageCount;
          this.$root.showLoader = false;
          localStorage.removeItem('bookmarkFilter');
          if (this.compareEvent(constants.EVENT.CREATE_PRACTICE_SESSION)) {
            this.removeEvent()
            this.requestCreateTest();
          }
          this.$forceUpdate();
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    requestGetRefData() {
      let reqData = { keys: ["QUESTION_TYPE"] };
      this.getRefData(reqData)
        .then((response) => {
          this.loading = false;
          this.headers[2].options = response.QUESTION_TYPE.filter(
            (xx) =>
              xx.id != 14 &&
              xx.id != 15 &&
              xx.id != 16 &&
              xx.id != 17 &&
              xx.id != 18 &&
              xx.id != 20 &&
              xx.id != 21 &&
              xx.id != 23 &&
              xx.id != 24
          ).map((x) => {
            let c = {};
            c.text = x.value;
            c.value = x.id;
            c.checked = this.selectedQuestionType && this.selectedQuestionType.includes(x.id) ? true : false;
            return c;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    requestGetResponseData() {
      this.headers[3].options = this.responseTypes.map((x) => {
        let c = {};
        c.text = x.title;
        c.value = x.code;
        c.checked = this.selectedResponseType && this.selectedResponseType.includes(x.code) ? true : false;
        return c;
      });
    },
  requestCreateTest() {
      if (this.validate(true) && !this.checkStudentUpgraded()) {
        this.$root.showLoader = true;
        let reqData = {
          test_name: this.testName, // from constansts.js
          chapter_id: this.chapterId && this.chapterId.length ? this.chapterId : [],
          subject_id: this.subjectId,
          required_pyq: 0,
          topic_id: this.topic_id || [],
          question_types: this.selectedQuestionType && this.selectedQuestionType.length ? this.selectedQuestionType : constants.QUESTION_TYPES_PS[2].value,
          test_sub_type: this.testSubType, // from constansts.js
          test_type: this.testType, // from constansts.js
          question_id: this.items.map(a => a.question_id) || [],
          isRetryShortlisted: true,
        };
        this.createTestForPracticeSession(reqData)
          .then((response) => {
            this.$root.showLoader = false;
            this.removeSessionData();
            localStorage.setItem(
              "session_start",
              response.practice_session.start_time
            );
            localStorage.setItem("previousPath", this.$route.path);
            this.$router.push({
              name: "practice-session-question-view",
              params: {
                practice_session_id: response.practice_session.id,
                subject_id: response.practice_session.subject_id,
                test_id: response.id,
                topicsSelected: this.topic_id && this.topic_id.length > 0 ? 1 : 0,
              },
            });
          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      }
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requestGetQuestions();
    },
    validate(show) {
      let isValid = true;
      if (!this.subjectId) {
        if (show) {
          this.$toasted.error(
            "Please Select a Subject and a Chapter to Retry Questions"
          );

        }
        isValid = false;
      } else if (!this.chapterId || !this.chapterId.length) {
        if (show) {
          this.$toasted.error(
            "Please Select a Chapter to Retry Questions"
          );

        }
        isValid = false;
      }
      return isValid;
    },
  },
  watch: {
    selectedQuestionType(val) {
      if (val && val.length) {
        this.onFilterChange();
      }
    },
    subjectId(val) {
      console.log(!this.isApiCall);
      if (val) {
        this.onFilterChange();
      }
    },
    chapterId(val) {
      if (val) {
        this.onFilterChange();
      }
    },
    topicId(val) {
      if (val) {
        this.onFilterChange();
      }
    },
    testTypeId(val) {
      if (val && val.length) {
        this.onFilterChange();
      }
    },
    selectedResponseType(val) {
      if (val && val.length) {
        this.onFilterChange();
      }
    },
    loadQuestions(val) {
      if (val && !this.isApiCall) {
        this.onFilterChange();
      }
    },
  },
};
</script>
